<template>
  <div class="ai-editor">
    <div class="editor-content">
      <div class="rich-editor-wrapper">
        <MyTinymce
          :placeholder="'请输入工作计划内容'"
          v-model="richContent"
          type="AIPlan"
          ref="AIPlan"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MyTinymce from '@/components/Editor/index.vue'

export default {
  name: 'AiEditor',
  components: {
    MyTinymce,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    height: {
      type: Number,
      default: 400,
    },
  },
  data() {
    return {
      activeTab: 'rich',
      richContent: '',
      vditor: null,
      markdownContent: '',
    }
  },
  watch: {
    value(newVal) {
      this.richContent = newVal
    
    },
    richContent(newVal) {
      this.$emit('input', newVal)
    },
  },
  mounted() {
    this.richContent = this.value
  },
  beforeDestroy() {
    if (this.vditor) {
      this.vditor.destroy()
      this.vditor = null
    }
  },
  methods: {
    setContent(content) {
      this.richContent = content
    },
    getContent() {
      return this.richContent
    },
  },
}
</script>

<style lang="less" scoped>
.ai-editor {
  width: 100%;
  .editor-tabs {
    margin-bottom: 12px;
    :deep(.ant-tabs-nav) {
      margin-bottom: 0;
    }
  }
  .editor-content {
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    overflow: hidden;
    .rich-editor-wrapper {
      :deep(.room) {
        margin: 0;
      }
    }
    .markdown-editor-wrapper {
      .vditor-container {
        width: 100%;
        min-height: 360px;
      }
    }
  }
}
</style>
